import 'expose?Tether!tether';
import 'owl.carousel/dist/owl.carousel.min';
import '../css/theme';


var opencart_responsive_current_width = window.innerWidth;
var opencart_responsive_min_width = 992;
var opencart_responsive_mobile = opencart_responsive_current_width < opencart_responsive_min_width;
var header_link_default = $('#_desktop_link_menu').html(); 

$(document).ready(() => {

    $('#siteloader').fadeOut();
    $('#spin-wrapper').fadeOut();

    // var headerHeight = $('#header').height();
    // var navHeight = $('#header .nav-full-width').height();
    // $(window).scroll(function(){
    //     if ($(window).scrollTop() > headerHeight) {
    //         $('.nav-full-width').addClass('fixed-header');
    //     }
    //     else {
    //         $('.nav-full-width').removeClass('fixed-header');
    //     }
    // });

    $(".dropdown-toggle").click(function(){
        $(this).siblings(".dropdown-menu").slideToggle("slow");
    });

    $('#search_widget .search-logo').click(function() {
        $(this).toggleClass('active').parents('#search_widget').find('form').stop(true,true).slideToggle('medium');
    });

    $('.ishicategoryblock .category-logo').click(function() {
        $(this).toggleClass('active').parents('.ishicategoryblock').find('.category-list').stop(true,true).slideToggle('medium');
    });

    $(document).on('click','.btn-block',function() {
        $(this).siblings('.cart-dropdown').stop(true,true).slideToggle();
    });

    /* SlideTop*/
    $(window).scroll(function() {
        if ($(this).scrollTop() > 500) {
            $('#slidetop').fadeIn(500);
        } else {
            $('#slidetop').fadeOut(500);
        }
    });

    $('#slidetop').click(function(e) {
        e.preventDefault();     
        $('html, body').animate({scrollTop: 0}, 800);
    });   

    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
    if(!isMobile) {
    	if($(".parallax").length) {
    		$(".parallax").sitManParallex({  invert: false });
    	};
    } else {
    	$(".parallax").sitManParallex({  invert: true });
    }

    adjustTopMenu();

    if($('.ishiparallaxbannerblock .parallax').data('deal') == '1') {
       var time = $('.ishiparallaxbannerblock .parallax').data('counter');
        var container = $('.ishiparallaxbannerblock .parallax').find('#parallaxcountdown');

        $(container).countdown(time, function(event) {
            $(this).find(".countdown-days .data").html(event.strftime('%D'));
            $(this).find(".countdown-hours .data").html(event.strftime('%H'));
            $(this).find(".countdown-minutes .data").html(event.strftime('%M'));
            $(this).find(".countdown-seconds .data").html(event.strftime('%S'));
            ;
        });
    }

    $('.products-block .owl-carousel').owlCarousel({
        loop:false,
        nav:true,  
        dots:false,    
        rewind: true,
        rtl: $('html').attr('dir') == 'rtl'? true : false,
        navText: ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
        responsive:{
            0:{
                items:1
            },
            543:{
                items:2
            },
            767:{
                items:3
            },
            991:{
                items:3
            },
            1200:{
                items:3
            },
            1400:{
                items:4
            }
        }
    });    

    $('#ishitestimonials-carousel').owlCarousel({
        loop:false,
        nav:false,
        autoplay:false,
        items:1,
        rtl: $('html').attr('dir') == 'rtl'? true : false,
    });  
    
    // $('#top_menu_closer i').on('click', function() {
    //   if($('body').hasClass('lang-rtl')) {
    //     $('#mobile_top_menu_wrapper').toggle("slide", {direction: "right"}, 400);
    //   } else {
    //     $('#mobile_top_menu_wrapper').toggle("slide");
    //   }
    // });


    // $('#menu-icon').on('click', function() {
    //   if($('body').hasClass('lang-rtl')) {
    //     $('#mobile_top_menu_wrapper').toggle("slide", {direction: "right"}, 400);
    //   } else {
    //     $('#mobile_top_menu_wrapper').toggle("slide");
    //   }
    // });

    $('#menu-icon').on('click', function() {
    $("#mobile_top_menu_wrapper").animate({
      width: "toggle"
    });
  });

      $('#top_menu_closer i').on('click', function() {
        $("#mobile_top_menu_wrapper").animate({
          width: "toggle"
        });
      });
 
    if (opencart_responsive_mobile) {
        toggleMobileStyles();
    }
    
	function myFunction(x) {
	    if (x.matches) {
	    	var list = $('.headerlink-dropdown').find('.small').html();
	    	$('.viewmore-container').remove();
	    	$('.link_container').append(list);
            $('.link_container').removeClass('large');
            $('.link_container').addClass('small');  
            $('#header_ishiheaderlinks').append('<span class="link-icon"></span>')
            .append('<h4 class="small-title">'+ $('#menu_text').text()  +'</h4>')
            .append('<div class="link-menu"><div class="wrapper-menu"><div class="line-menu half start"></div><div class="line-menu"></div><div class="line-menu half end"></div></div></div>');

	    } else {
            $('#header_ishiheaderlinks .link-icon').remove();
            $('#header_ishiheaderlinks .link-menu').remove();
            $('#header_ishiheaderlinks .small-title').remove();
            $('.link_container').removeClass('small');
            $('.link_container').addClass('large');
	    	var bigList = $('<ul class="bullet large link_container"></ul>');
			var smallList = $('<ul class="small"></ul>');
            if ($('#_desktop_link_menu ul.link_container li').length <= 5)
                return;
	    	$.each($('#_desktop_link_menu ul.link_container li'), function( i, val){
		    	if(i < 5) {
		    		bigList.append(val);
		    	} else {
		    		smallList.append(val);
		    	}
		    });
	    	bigList.append('<li class="viewmore-container"><a class="viewmore" href="javascript:void(0)">'+ $('#view_text').text() +'</a><div class="headerlink-dropdown"></div></li>');
    		bigList.find('.headerlink-dropdown').append(smallList);
	        $('.link_container').replaceWith(bigList);
	    }
	}
    $('#_desktop_link_menu').show();
	var x = window.matchMedia("(max-width : 1200px)");
	myFunction(x); // Call listener function at run time
	x.addListener(myFunction); // Attach listener function on state changes 

});

 
$(window).on('resize', function() {
    var _cw = opencart_responsive_current_width;
    var _mw = opencart_responsive_min_width;
    var _w = window.innerWidth;
    var _toggle = (_cw >= _mw && _w < _mw) || (_cw < _mw && _w >= _mw);
    opencart_responsive_current_width= _w;
    opencart_responsive_mobile = opencart_responsive_current_width < opencart_responsive_min_width;
    if (_toggle) {
        toggleMobileStyles();
    }
});     


  
function adjustTopMenu() {
    if (window.matchMedia('(min-width: 1200px)').matches) {
        $( "#_desktop_top_menu #top-menu .top_level_category" ).each(function( index ) {
          var subdiv = $(this).find('.sub-menu .category_dropdownmenu').length;
          var submenu = $(this).find('.sub-menu');
          if (subdiv == 1){
                submenu.css('width','230px');   
            }
            else{
                submenu.css('width',subdiv*200+30+'px');
            }
        });
    }
    else if (window.matchMedia('(min-width: 991px)').matches) {
        $( "#_desktop_top_menu #top-menu .top_level_category" ).each(function( index ) {
          var subdiv = $(this).find('.sub-menu .category_dropdownmenu').length;
          var submenu = $(this).find('.sub-menu');
          if (subdiv == 1){
                submenu.css('width','230px');
            } else if(subdiv < 4) {
                submenu.css('width',subdiv*200+30+'px');
            }
            else{
                submenu.css('width','830px');
            }
        });
    }
    else if (window.matchMedia('(max-width: 991px)').matches) {
        $( "#_mobile_top_menu #top-menu .top_level_category" ).each(function( index ) {
          var subdiv = $(this).find('.sub-menu .category_dropdownmenu').length;
          var submenu = $(this).find('.sub-menu');
          if (subdiv == 1){
                submenu.css('width','auto');   
            }
            else{
                submenu.css('width','auto');
            }
        });
    }

}


function swapChildren(obj1, obj2)
{
    var temp = obj2.children().detach();
    obj2.empty().append(obj1.children().detach());
    obj1.append(temp);
}



function toggleMobileStyles()
{
    if (opencart_responsive_mobile) {
        $("*[id^='_desktop_']").each(function(idx, el) {
            var target = $('#' + el.id.replace('_desktop_', '_mobile_'));
            if (target.length) {
                swapChildren($(el), target);
            }
        });
    } else {
        $("*[id^='_mobile_']").each(function(idx, el) {
            var target = $('#' + el.id.replace('_mobile_', '_desktop_'));
            if (target.length) {
                swapChildren($(el), target);
            }
        });
    }
}


// WEBPACK FOOTER //
// ./js/theme.js